import {NutritionValue} from "@/entities/nutrition-value";
import pick from "lodash/pick";

export default class ProductNutritionOverrideEntity {
  public id!:number;

  public calorie:NutritionValue = new NutritionValue(null);
  public lipid:NutritionValue = new NutritionValue(null);
  public protein:NutritionValue = new NutritionValue(null);
  public carb:NutritionValue = new NutritionValue(null);
  public salt:NutritionValue = new NutritionValue(null, 'salt');

  constructor(init:Partial<ProductNutritionOverrideEntity> = {}) {
    this.nonNutritionKeys.forEach(k => {
      if (k in init) {
        this[k] = init[k];
      }
    });

    this.getNutritionKeys(this).forEach(k => {
      if (k in init) {
        this[k] = new NutritionValue(init[k], k);
      }
    });
  }
  protected get nonNutritionKeys() {
    return ['id','productId'];
  }
  protected getNutritionKeys(obj) {
    return Object.keys(obj).filter(k => !['id'].includes(k));
  }

  public getNutrition(prop:string): NutritionValue{
    return this[prop];
  }

  public get saltValue():NutritionValue {
    return this.salt;
  }

  public serialize(): ProductNutritionOverrideEntity {
    const nutriValues = pick(this, this.getNutritionKeys(this));
    Object.keys(nutriValues).forEach(key => {
      nutriValues[key] = nutriValues[key].original;
    });
    return Object.assign(pick(this, this.nonNutritionKeys), nutriValues) as any;
  }

}

